module.exports = __webpack_public_path__ + "entry-41b28522/malte-balmer.256x256-2543b1a691b30814a8a8be11822ae762.webp";